'use client';

import { analytics } from '@lib/analytics/page-events';
import { Accordion as AccordionType } from '@lib/types/cms/Accordion';

import { Accordion, AccordionItem } from 'ui-components';
import { BlocksTitle } from '../shared/BlocksTitle';

type AccordionBlockProps = {
  data: AccordionType;
};

const AccordionBlock = ({ data }: AccordionBlockProps) => {
  const { title, description, text, sections } = data;

  const accordionItems: AccordionItem[] = sections.map((section) => ({
    title: section.title,
    content: section.content,
  }));

  if (accordionItems.length === 0) {
    return null;
  }

  return (
    <div className="main-grid">
      <div className="col-span-4 md:col-span-8 md:col-start-3 md:col-end-11">
        {(title || description || text) && (
          <div className="mb-8 md:text-center">
            <BlocksTitle title={title} description={description} text={text} />
          </div>
        )}
        <Accordion
          headingLevel="h3"
          items={accordionItems}
          onAccordionAction={(heading, action) => {
            analytics.pushAccordionClickEvent({
              faq_action_name: heading,
              faq_action: action,
            });
          }}
        />
      </div>
    </div>
  );
};

export default AccordionBlock;
